module.exports = __webpack_public_path__ + "img/retailing.8d96bac0.svg";